import { render, staticRenderFns } from "./index-format.vue?vue&type=template&id=44379c4b&scoped=true&"
import script from "./index-format.vue?vue&type=script&lang=js&"
export * from "./index-format.vue?vue&type=script&lang=js&"
import style0 from "./index-format.vue?vue&type=style&index=0&id=44379c4b&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44379c4b",
  null
  
)

export default component.exports